import styled from 'styled-components'

import Section from 'components/Section/Section'
import { Text } from 'components/Text/Text'

export const HomeSearchSection = styled(Section)`
  padding: 6rem 0 3rem;
`

export const HomeSearchTItle = styled(Text)`
  margin: 0 0 2.5rem;
`

export const HomeSearchPartners = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
export const HomeSearchPartner = styled.img`
  margin-right: 2.5rem;
  &:last-child {
    margin: 0;
  }
`

export const HomeSearchFormContainer = styled.form`
  max-width: 768px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
/*   justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.white}; */
  height: 59px;
  border-radius: 5px;
  overflow: hidden;
  margin: 0 auto 3rem auto;
`

export const HomeSearchFormInput = styled.input`
  appearance: none;
  border: none;
  outline: none;
  background: none;
  height: 100%;
  width: 100%;
  padding: 0 2rem 0 3rem;
  font-size: 1.375rem;
  line-height: 1.375rem;
  &::placeholder {
    color: #e5e5e5;
    font-size: 1.375rem;
    line-height: 1.375rem;
    font-family: ${({ theme }) => theme.fonts.secondary}, sans-serif;
    font-style: italic;
  }
`
export const HomeSearchFormDivider = styled.div`
  height: 80%;
  width: 1px;
  background-color: #e5e5e5;
`
export const HomeSearchFormButton = styled.button`
  appearance: none;
  border: none;
  outline: none;
  background: none;
  height: 100%;
  width: 150px;
  flex: 1 0 auto;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.primary};
  text-transform: uppercase;
  font-size: 0.875rem;
  line-height: 0.875rem;
  font-weight: 500;
  transition: all 0.25s ease-in-out;
  font-family: ${({ theme }) => theme.fonts.main}, sans-serif;
  &:hover {
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.primary};
  }
`
